import { ComponentType } from '@angular/cdk/overlay';
import { MaintenanceColumnKeys } from '../../app/pages/maintenance/maintenance-task/enums/maintenance-column-keys.enum';
import { MaintenanceFilterType } from '../../app/pages/maintenance/maintenance-task/enums/maintenance-filter-type.enum';
import { BaseDataControl } from '../../app/pages/resources/equipment/components/equipments-details/components/general-data/base-data/enums/base-data-control.enum';
import { EquipmentColumnKeys } from '../../app/pages/resources/equipment/enums/equipment-column-keys.enum';
import { EquipmentFilterType } from '../../app/shared/filters/enums/equipment-filter-type.enum';
import {
  Whitelabel,
  WhitelabelFilterType,
  WhitelabelPropertyType,
  WhitelabelTableType,
  WhitelabelVisibilityOption,
} from '../../app/whitelabel/contract/whitelabel.contract';
import { IconsetKey } from '../iconset-key.enum';
import { ThemeKey } from '../theme-key.enum';
import { WhitelabeledComponentKey } from '../whitelabel-component-types';

export const Wackerneuson: Whitelabel = {
  whitelabeledComponents: {
    [WhitelabeledComponentKey.APP_SWITCHER]: (): Promise<ComponentType<unknown>> =>
      import('./components/wn-quick-links-menu/wn-quick-links-menu.component').then((m) => m.WnQuickLinksMenuComponent),
    [WhitelabeledComponentKey.USER_SETTINGS_MENU]: (): Promise<ComponentType<unknown>> =>
      import('./components/user-settings-menu/user-settings-menu.component').then((m) => m.UserSettingsMenuComponent),
    [WhitelabeledComponentKey.SIDEBAR_MENU]: (): Promise<ComponentType<unknown>> =>
      import('./components/wn-sidebar/sidebar.component').then((m) => m.WNSidebarComponent),
  },
  iconSet: IconsetKey.WN,
  defaultTheme: ThemeKey.WACKER_NEUSON_LIGHT,
  availableThemes: [ThemeKey.WACKER_NEUSON_LIGHT, ThemeKey.WACKER_NEUSON_DARK],
  customization: {
    visibility: {
      properties: {
        [WhitelabelPropertyType.EQUIPMENT]: {
          type: WhitelabelVisibilityOption.WHITELIST,
          properties: [
            BaseDataControl.EQUIPMENT_NAME,
            BaseDataControl.EQUIPMENT_CUSTOMER_SERIAL_NUMBER,
            BaseDataControl.ORGANISATION_NAME,
            BaseDataControl.EQUIPMENT_MANUFACTURER,
            BaseDataControl.EQUIPMENT_MODEL,
            BaseDataControl.EQUIPMENT_CLASS,
            BaseDataControl.EQUIPMENT_CONSTRUCTION_YEAR,
            BaseDataControl.EQUIPMENT_DELIVERY_DATE,
            BaseDataControl.EQUIPMENT_TYPE,
            BaseDataControl.OPERATING_HOURS,
            BaseDataControl.CURRENT_MILEAGE,
            BaseDataControl.CURRENT_ADDRESS,
            BaseDataControl.EQUIPMENT_SERIAL_NUMBER,
          ],
        },
      },
      tableColumns: {
        [WhitelabelTableType.EQUIPMENT_LIST]: {
          type: WhitelabelVisibilityOption.WHITELIST,
          columns: [
            EquipmentColumnKeys.IMAGE,
            EquipmentColumnKeys.NAME,
            EquipmentColumnKeys.CUSTOMER_NAME,
            EquipmentColumnKeys.CUSTOMER_SERIAL_NUMBER,
            EquipmentColumnKeys.SERIAL_NUMBER,
            EquipmentColumnKeys.LABELS,
            EquipmentColumnKeys.MODEL,
            EquipmentColumnKeys.TYPE_CATEGORY1,
            EquipmentColumnKeys.TYPE_CATEGORY2,
            EquipmentColumnKeys.MANUFACTURER_NAME,
            EquipmentColumnKeys.CURRENT_ADDRESS,
            EquipmentColumnKeys.STATUS,
            EquipmentColumnKeys.CONSTRUCTION_YEAR,
            EquipmentColumnKeys.CURRENT_OPERATING_HOURS,
            EquipmentColumnKeys.OPERATING_HOURS_LAST_UPDATED,
            EquipmentColumnKeys.CURRENT_MILEAGE,
            EquipmentColumnKeys.MILEAGE_LAST_UPDATED,
            EquipmentColumnKeys.REGISTRATION_DATE,
            EquipmentColumnKeys.DETAILS,
            EquipmentColumnKeys.ATTENTION_STATUS,
            EquipmentColumnKeys.CORE_DATA,
            EquipmentColumnKeys.EQUIPMENT_FAVOURITE,
            EquipmentColumnKeys.EQUIPMENT_NONE,
            EquipmentColumnKeys.EQUIPMENT_TELEMATICS_UNIT,
            EquipmentColumnKeys.LAST_TELEMATICS_UPDATE,
            EquipmentColumnKeys.ASSIGNED_TELEMATICS_UNIT,
            EquipmentColumnKeys.TELEMATICS_UNIT_TYPE,
            EquipmentColumnKeys.CURRENT_ACTIVITY_STATUS,
          ],
        },
        [WhitelabelTableType.MAINTENANCE_LIST]: {
          type: WhitelabelVisibilityOption.WHITELIST,
          columns: [
            MaintenanceColumnKeys.ICON,
            MaintenanceColumnKeys.NAME,
            MaintenanceColumnKeys.CATEGORY,
            MaintenanceColumnKeys.EQUIPMENT,
            MaintenanceColumnKeys.EQUIPMENT_CUSTOMER_SERIAL_NUMBER,
            MaintenanceColumnKeys.CUSTOMER_NAME,
            MaintenanceColumnKeys.DUE_DATE,
            MaintenanceColumnKeys.DUE_OPERATING_HOURS,
            MaintenanceColumnKeys.REMAINING_TIME,
            MaintenanceColumnKeys.WARNING_LEVEL,
            MaintenanceColumnKeys.EQUIPMENT_TYPE_CATEGORY2,
            MaintenanceColumnKeys.EQUIPMENT_SERIAL_NUMBER,
            MaintenanceColumnKeys.EQUIPMENT_LABELS,
            MaintenanceColumnKeys.EQUIPMENT_MODEL,
            MaintenanceColumnKeys.EQUIPMENT_MANUFACTURER_NAME,
            MaintenanceColumnKeys.CURRENT_ADDRESS,
            MaintenanceColumnKeys.STATUS,
            MaintenanceColumnKeys.EQUIPMENT_CONSTRUCTION_YEAR,
            MaintenanceColumnKeys.CURRENT_OPERATING_HOURS,
            MaintenanceColumnKeys.EQUIPMENT_REGISTRATION_DATE,
            MaintenanceColumnKeys.TELEMATIC,
            MaintenanceColumnKeys.TELEMATIC_LOCATION,
            MaintenanceColumnKeys.ACTIONS,
          ],
        },
      },
      filters: {
        [WhitelabelFilterType.MAINTENANCE_LIST]: {
          type: WhitelabelVisibilityOption.WHITELIST,
          filters: [
            MaintenanceFilterType.LABEL,
            MaintenanceFilterType.MAINTENANCE_TYPES,
            MaintenanceFilterType.EQUIPMENT_TYPES,
            MaintenanceFilterType.DUE_DATE,
            MaintenanceFilterType.EQUIPMENT_LOCATIONS,
            MaintenanceFilterType.MAINTENANCE_CATEGORY,
            MaintenanceFilterType.MATCH_ALL_LABELS,
            MaintenanceFilterType.CUSTOMERS,
            MaintenanceFilterType.MODEL,
            MaintenanceFilterType.MANUFACTURER,
          ],
        },
        [WhitelabelFilterType.EQUIPMENT_LIST]: {
          type: WhitelabelVisibilityOption.WHITELIST,
          filters: [
            EquipmentFilterType.LABEL,
            EquipmentFilterType.CLASS,
            EquipmentFilterType.FAVOURITE_ONLY,
            EquipmentFilterType.MATCH_ALL_LABELS,
            EquipmentFilterType.ATTENTION_STATUS,
            EquipmentFilterType.ACTIVITY_STATUS,
            EquipmentFilterType.COMPLETENESS_STATUS,
            EquipmentFilterType.LAST_SEEN,
            EquipmentFilterType.MODEL,
            EquipmentFilterType.MANUFACTURER,
            EquipmentFilterType.CUSTOMER,
            EquipmentFilterType.CONSTRUCTION_YEAR,
          ],
        },
      },
    },
    translationKeyOverrides: {
      'general.customer.s': 'general.org.s',
      'general.customer.pl': 'general.org.pl',
      'shared.pipes.alarmSelectionType.customer': 'shared.pipes.alarmSelectionType.organization',
      'general.label.s': 'general.fleet.s',
      'general.label.pl': 'general.fleet.pl',
      'modules.notification.alarmRuleAddEdit.labels.equipmentLabels':
        'modules.notification.alarmRuleAddEdit.labels.equipmentFleets',
      'shared.pipes.alarmSelectionType.labels': 'shared.pipes.alarmSelectionType.fleets',
      'shared.pipes.searchFilterType.label': 'shared.pipes.searchFilterType.fleet',
      'modules.equipment.labels.noLabelAssigned': 'modules.equipment.labels.noFleetAssigned',
      'modules.notification.alarmRuleAddEdit.placeholders.customer':
        'modules.notification.alarmRuleAddEdit.placeholders.organisation',
      'modules.notification.alarmRuleAddEdit.labels.customer':
        'modules.notification.alarmRuleAddEdit.labels.organisation',
      'general.standalone.s': 'general.standalone.equipcare.s',
      'shared.pipes.equipmentEventType.standalone.osp': 'shared.pipes.equipmentEventType.standalone.equipcare',
      'help.general.helpcenter.osp.content': 'help.general.helpcenter.wn.content',
      'modules.maintenance.task.shiftStandaloneTask': 'modules.maintenance.task.shiftStandaloneTask-equipcare',
      'modules.maintenance.completedTasks.attachment.tooltipDisabledStandaloneCompleted':
        'modules.maintenance.completedTasks.attachment.tooltipDisabledStandaloneCompleted-equipcare',
      'modules.maintenance.base.completeReminder': 'modules.maintenance.base.completeReminder-equipcare',
      'modules.maintenance.confirmation.completeReminder':
        'modules.maintenance.confirmation.completeReminder-equipcare',
      'modules.maintenance.unassignReminder.confirmationTitle':
        'modules.maintenance.unassignReminder.confirmationTitle-equipcare',
      'modules.maintenance.unassignReminder.unassign': 'modules.maintenance.unassignReminder.unassign-equipcare',
      'modules.maintenance.unassignReminder.confirmationMessage':
        'modules.maintenance.unassignReminder.confirmationMessage-equipcare',
      'modules.maintenance.reminderCreate.reminderName': 'modules.maintenance.reminderCreate.reminderName-equipcare',
      'modules.maintenance.reminderCreate.reminderNamePlaceholder':
        'modules.maintenance.reminderCreate.reminderNamePlaceholder-equipcare',
      'modules.maintenance.reminderCreate.addReminder': 'modules.maintenance.reminderCreate.addReminder-equipcare',
      'general.reminder': 'general.reminder-equipcare',
      'modules.equipment.confirmation.title.deleteReminder':
        'modules.equipment.confirmation.title.deleteReminder-equipcare',
      'modules.maintenance.toast.deleteReminderSuccess.title':
        'modules.maintenance.toast.deleteReminderSuccess.title-equipcare',
      'messages.toast.completeReminderSuccess.title': 'messages.toast.completeReminderSuccess.title-equipcare',
      'modules.maintenance.maintenanceDueDateEdit.titleEditDate':
        'modules.maintenance.maintenanceDueDateEdit.titleEditDate-equipcare',
    },
  },
};
